export default "__VITE_ASSET__B$hIouth__"